import { render, staticRenderFns } from "./OptionEditor.vue?vue&type=template&id=303dc886"
import script from "./OptionEditor.vue?vue&type=script&lang=js"
export * from "./OptionEditor.vue?vue&type=script&lang=js"
import style0 from "./OptionEditor.vue?vue&type=style&index=0&id=303dc886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports